import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { SubEntities } from 'src/app/core/models/globals';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-synchpc-license-info',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule],
  templateUrl: './synchpc-license-info.component.html',
  styleUrls: ['./synchpc-license-info.component.scss'],
})

export class SynchpcLicenseInfoComponent implements OnInit {
    info: any;
    objectKeys: string[] = [];
    isLoading: boolean = false;
    error: string = '';
    
    constructor(
      private configEntityService: ConfigEntityService,
      private navService: NavigationService,
      private spinner: NgxSpinnerService,
    ) {}

    ngOnInit() {
      this.configEntityService.sendActiveEntity('SyncHPC License');
      this.navService.sendChildData('SyncHPC License');
      this.navService.sendParentData('');
      this.fetchInfo();
    }

    private fetchInfo(): void {
        try{
            this.spinner.show("keySpinner");
            this.isLoading = true;
            this.configEntityService.getSyncHPCLicenseInfoService().subscribe({
                next: (data) => {
                if(data) {
                    this.spinner.hide("keySpinner");
                    this.isLoading = false;
                    this.info = data;
                    this.initializeData();
                }
                },
                error: (error) => {
                    this.spinner.hide("keySpinner");
                    this.isLoading = false;
                    console.error('Error fetching SyncHPC License Info:', error);
                }
            });
        }
        catch (error) {
            this.spinner.hide("keySpinner");
            this.isLoading = false;
            this.error = 'Failed to fetch SyncHPC License Info. Please try again later.';
            console.error('Error fetching SyncHPC License Info:', error);
        }
    }

    initializeData(): void {
        try{
            if (this.info && typeof this.info === 'object') {
                this.objectKeys = Object.keys(this.info).filter(key => 
                    key.toLowerCase().indexOf('password') == -1
                );
            }
        }
        catch (error) {
            console.error('Error initializing data:', error);
            this.error = 'Failed to initialize SyncHPC License Info. Please try again later.';
            this.isLoading = false;
            this.spinner.hide("keySpinner");
        }
        
    }

    refreshData(): void {
        this.fetchInfo();
    }

    formatLabel(key: string): string {
        if (!key) return '';
        return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase());
    }

    getValueType(value: any): string {
        if (value === null || value === undefined) {
            return 'empty';
        }
        if (value instanceof Date || (typeof value === 'string' && !isNaN(Date.parse(value)))) {
            return 'date';
        }
        if (typeof value === 'string' && value.toLowerCase().includes('password')) {
            return 'password';
        }
        return 'default';
    }

    getValue(value: any): any {
        if (!value) return '-';
        
        try {
            if (this.getValueType(value) === 'date') {
                const date = new Date(value);
                return isNaN(date.getTime()) ? '-' : date;
            }
            return value;
        } catch (error) {
            console.warn('Error processing value:', error);
            return '-';
        }
    }

    isEmpty(value: any): boolean {
        return value === null || 
              value === undefined || 
              value === '' || 
              (typeof value === 'number' && isNaN(value));
    }

    retryFetch(): void {
        if (!this.isLoading) {
            this.fetchInfo();
        }
    }
}
